const subjects = {
  ai: {18: [1,2,3]},
  bcc: {18: [2,3]},
  c: { 16: [1, 2, 3] },
  cc: {19: [1]},
  cd: { 15: [1, 2, 3], 18: [1,2,3] },
  cla: { 15: [1, 2, 3], 17:[3] },
  cnc: { 15: [1, 3] , 18:[1,3]},
  cns: { 15: [1, 2, 3], 19: [1,2] },
  coa: { 15: [1, 2, 3], 17: [1,2,3] },
  daa: { 15: [1, 3], 18: [1,2] },
  dbms: {18: [2,3]},
  de: { 15: [1, 2, 3], 17: [1,2,3] },
  dhv: { 15: [1, 3] },
  dhv_mech:{19: [1,2,3]},
  pe: {17: [1]},
  ds: { 15: [1, 2, 3] , 17: [1,2]},
  dsa: {19:[1,3]},
  dsm: { 16: [1, 2, 3] },
  dsdvhdl: {17: [2]},
  eg: { 15: [1, 2, 3], 16: [2] },
  fop: { 15: [1, 2, 3] },
  hpc: {19: [1]},
  iot: {19: [1,3]},
  itl: {18: [2,3]},
  itl_mech : {19:[1]},
  jp: { 15: [3], 18: [1,2,3] },
  mc:{19: [1]},
  mi: { 15: [1], 18: [1,2,3] },
  ml: {18: [1,2], 20: [1]},
  mkm: {18: [1,2,3]},
  oops: { 16: [1, 3], 18:[1] },
  os: { 16: [1, 3], 18: [2,3] },
  toc: { 15: [1], 16: [1], 18:[1] },
  sc: {19: [3]},
  se: {19: [1,2,3]},
  clam: {15: [1,2,3]},
  ed: {15: [1,2,3], 19: [1,2,3]},
  em: {15: [1,2,3], 19:[1,2,3]},
  emi: {19:[2]},
  emii: {19:[1,2,3]},
  env: {19:[1,3]},
  fm: {15: [1,3], 19: [1]},
  fmac: {16: [1,2,3]},
  itca: {15: [1,2,3]},
  km: {15: [1,2,3]},
  md: {16: [1,3]},
  mp: {15: [1,2,3], 17: [1,2,3], 19: [1]},
  mpr: {15: [1,2,3]},
  mse: {16: [1,2,3], 19: [1,2,3]},
  pc: {15: [1,2,3]},
  pp_mech: {19: [1,2,3]},
  prof_comm: {19: [2]},
  som: {15: [1,2,3], 19: [2]},
  td: {16: [1,2,3], 19: [2]},
  te: {16: [1,2,3]},
  vcde: {16: [1,2,3]},
  ace: {15: [2,3], 17: [2]},
  awp: {15: [1,3], 18: [1,3]},
  bee: {15: [1,2,3], 16: [2,3]},
  csys: {15: [1,2,3]},
  del: {15: [1,2,3], 18:[3]},
  digc: {15: [1], 18:[3]},
  ecs: {16: [1,2,3]},
  eft: {15: [1,2,3]},
  esm: {15: [1,3]},
  ieng: {15: [1,3]},
  nas: {16: [1,2,3], 17: [1,3]},
  pce: {16: [1,2,3], 17: [3]},
  spls: {15: [1,3]},
  vcdee: {16: [1,2,3], 17:[1]},
  lica: {18: [1,2]}
};

export { subjects };
